var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React, { Fragment } from "react";
import { artActionPricesCls, artActionPriceTagCls, artActionInstalmentsCls, artActionInstalmentsHintCls, artActionHintWrapperCls } from "./Action.less";
var ArtActionPrice = /* @__PURE__ */ __name(function ArtActionPrice2(_ref) {
  var price = _ref.price, canBuyInInstalments = _ref.canBuyInInstalments, instalments = _ref.instalments;
  return /* @__PURE__ */ React.createElement("div", {
    className: artActionPricesCls
  }, /* @__PURE__ */ React.createElement("span", {
    className: artActionPriceTagCls
  }, price), canBuyInInstalments && instalments ? /* @__PURE__ */ React.createElement(Fragment, null, /* @__PURE__ */ React.createElement("span", {
    className: artActionInstalmentsCls
  }, instalments.info), /* @__PURE__ */ React.createElement("span", {
    className: "".concat(artActionInstalmentsHintCls, " ").concat(artActionHintWrapperCls)
  }, instalments.hint)) : null);
}, "ArtActionPrice");
export {
  ArtActionPrice
};
